<section>
    <div *ngIf="showIntegrationDashboard; else noIntegration">        
        <sp-dashboard-current-integration-display
            *ngIf="realTimeFinancialHealthReport$ | async"
            [reportData]="realTimeFinancialHealthReport$ | async"
            [fiscalYear]="fiscalYear"
            [transactions]="transactions$ | async"
            [financialAccounts]="financialAccounts$ | async"
            [property]="property$ | async"
            (generatePdfStart)="onGeneratePdfStarted()"
            (generatePdfFinish)="onGeneratePdfFinished()"
            [externalLedgerFunds]="generalLedgerFundConfigs$ | async"
            [integrationProperty]="integrationProperty$ | async">
        </sp-dashboard-current-integration-display>
    </div>

    <ng-template #noIntegration>
        <div>
            <div class="start-date">Start Date: {{(financialHealthReport$ | async)?.header?.fiscalYearStartDate | date: 'MMMM dd, yyyy'}}</div>
            <sp-dashboard-current-display
                *ngIf="financialHealthReport$ | async"
                [reportData]="financialHealthReport$ | async"
                (backToDashboard)="onBackToDashboard()">
            </sp-dashboard-current-display>
        </div>
    </ng-template>
</section>